<template>
  <v-card class="primary" dark height="355">
    <OrganismGallery :organism-id="item.id"></OrganismGallery>
    <v-card-title class="line-clamp-2" style="height: 96px">{{
      item.vernacularName
    }}</v-card-title>
    <v-card-subtitle class="pb-0" style="font-style:italic">{{
      item.scientificName || "-"
    }}</v-card-subtitle>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :to="'/costa-pez/administrador/especies/' + item.id"
        outlined
        rounded
        >Ver más</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import OrganismGallery from "./OrganismGallery";
export default {
  components: { OrganismGallery },
  props: ["item"],
  data: () => ({}),
  watch: {
    item: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      async handler(item) {
        this.$emit("update:item", item);
      }
    }
  },
  methods: {
    updateAttachementList(attachementList) {
      this.item.attachementList = attachementList || [];
    }
  }
};
</script>

<style></style>
